import { en, type Strings } from './en';

type PathsToLeaves<T, Prefix extends string = ''> = {
  [K in keyof T]: T[K] extends string
    ? `${Prefix}${K & string}`
    : T[K] extends object
    ? PathsToLeaves<T[K], `${Prefix}${K & string}.`>
    : never;
}[keyof T];

export type StringKey = PathsToLeaves<Strings>;

function getNestedValue(obj: Record<string, unknown>, path: string): string {
  const parts = path.split('.');
  let current: unknown = obj;
  for (const part of parts) {
    if (current == null || typeof current !== 'object') {
      console.warn(`[i18n] Missing key: ${path}`);
      return path;
    }
    current = (current as Record<string, unknown>)[part];
  }
  if (typeof current !== 'string') {
    console.warn(`[i18n] Key does not resolve to string: ${path}`);
    return path;
  }
  return current;
}

export function t(key: StringKey): string {
  return getNestedValue(en as unknown as Record<string, unknown>, key);
}

// React hook — returns bound t()
export function useT() {
  return t;
}
